export default {
  limitExceeded: {
    notes:
      'Tooltip displayed when the maximum number of favourites is reached.',
    message: 'The maximum number of favourites is {{limit}}.',
  },
};
